import { Compass } from 'lucide-react';
import { useActivityCount } from '../data/activity';
import { useCopy } from '../locales/useDiscoverStrings';

export function DiscoverIcon(props: { size?: number; strokeWidth?: number }) {
  const count = useActivityCount(), { t } = useCopy();
  return <span className="dc-section-icon"><Compass {...props} />{(count.data ?? 0) > 0 && <i data-testid="discover-section-dot" role="img" aria-label={t('web.unreadActivity')} />}</span>;
}
